import React, { useEffect, useRef, useState } from "react";
import "./Footer.css";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";

export default function Footer({ onSendMessage, isLoading, onResetChat }) {
  const textareaRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const { t: translator } = useTranslation();

  useEffect(() => {
    resizeTextarea();
  }, [inputValue]);

  const resizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      const newHeight = Math.min(textarea.scrollHeight, 100); // Cap to 100px
      textarea.style.height = `${newHeight + 2}px`;
    }
  };

  const handleSendMessage = () => {
    onSendMessage(inputValue);
    setInputValue("");
  };

  const isInputDisabled = isLoading;
  return (
    <div className="ai-chat-modal__footer">
      <Button
        onClick={onResetChat}
        disabled={isLoading}
        size="sm"
        className="text-neutral-500 hover:text-neutral-700 disabled:text-neutral-400 disabled:cursor-not-allowed"
      >
        <i className="fas fa-plus"></i>
      </Button>
      <div
        className={`footer__input-container ${
          isInputDisabled ? "footer__input-container--disabled" : ""
        }`}
      >
        <textarea
          ref={textareaRef}
          className="footer__input"
          disabled={isInputDisabled}
          value={inputValue}
          rows={1}
          placeholder={translator("AI-Chat-Placeholder-Message")}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyUp={(e) => {
            if (inputValue === "") return;
            if (e.key === "Enter" && e.shiftKey) {
              return;
            }
            if (e.key === "Enter" && inputValue.trim() !== "") {
              handleSendMessage();
            }
          }}
        />
      </div>
      <Button
        onClick={handleSendMessage}
        disabled={inputValue === "" || isLoading}
        size="sm"
      >
        <i className="far fa-paper-plane"></i>
      </Button>
    </div>
  );
}
